import { QueryEngine } from "../QueryEngine";


export const RenderQueryEngine = () => {
  return <QueryEngine />
};
